import Vue from "vue";
import DrawflowActorItem from "../../vue/backend/drawflow_actor_item.vue";
import DrawflowActorPropertyItem from "../../vue/backend/drawflow_actor_property_item.vue";
import DrawflowArticleMeasureItem from "../../vue/backend/drawflow_article_measure_item.vue";
import DrawflowHelpers from "../../vue/backend/drawflow_helpers";
import DrawflowMeasureItem from "../../vue/backend/drawflow_measure_item.vue";
import DrawflowMeasureWithOptionsItem from "../../vue/backend/drawflow_measure_with_options_item.vue";
import DrawflowPropertyItem from "../../vue/backend/drawflow_property_item.vue";
import Drawflow from "../drawflow.js";

const DrawflowWrapper = {
	assumedNodeWidth: 175,
	assumedNodeHeight: 100,
	dagreRangSep: 250,
	editorLinePath: 10,
	// Used to omit marking nodes as deleted when they are removed from remove, i.e. via `handleCmsEvents`
	emptyContextMenu: `<div class='dropdown open'><ul class='dropdown-menu'></ul></div>`,
	itemToModuleNames: {
		actor: "actors",
		property: "properties",
		actor_property: "properties",
		measure: "measures",
		measure_with_options: "measures",
		article_measure: "measures",
	},

	init(
		selector,
		importData,
		emptyNodes,
		modalsHtmlPerNodeType,
		inputsForParentNode,
		dropdownElements,
		gameId,
		activeModuleName = null,
	) {
		pp.log("into DrawflowWrapper", Object.keys(importData));

		this.importData = importData;
		this.emptyNodes = emptyNodes;
		this.modalsHtmlPerNodeType = modalsHtmlPerNodeType;
		this.inputsForParentNode = inputsForParentNode;
		this.dropdownElements = dropdownElements;
		this.gameId = gameId;

		if (importData.actors) {
			this.assumedNodeHeight = 10;
			this.assumedNodeWidth = 50;
			this.dagreRangSep = 10;
		}

		// @ts-expect-error
		this.editor = new Drawflow($(selector)[0], Vue, this);
		// Used to omit marking nodes as deleted when they are removed from remove, i.e. via `handleCmsEvents`
		this.editor.markNodesAsDeletedOnRemove = true;
		this.editor.deletedNodes = {};
		this.editor.gameId = gameId;

		this.editor.line_path = this.editorLinePath;
		if (!dropdownElements) {
			this.editor.editor_mode = "view";
		}
		this.setupListeners();

		this.editor.start();
		this.editor.registerNode("property", DrawflowPropertyItem);
		this.editor.registerNode("actor_property", DrawflowActorPropertyItem);
		this.editor.registerNode("measure", DrawflowMeasureItem);
		this.editor.registerNode(
			"measure_with_options",
			DrawflowMeasureWithOptionsItem,
		);
		this.editor.registerNode(
			"drawflow_article_measure_item",
			DrawflowArticleMeasureItem,
		);
		this.editor.registerNode("actor", DrawflowActorItem);

		Object.entries(importData).forEach(([moduleName, nodes]) => {
			// pp.log("at module", moduleName, nodes);
			this.editor.module = moduleName;
			this.editor.addModule(moduleName);
			this.importNodesFromRails(nodes);
		});

		// @ts-expect-error
		activeModuleName = activeModuleName || Object.keys(importData)[0];

		this.editor.on("beforeModuleChanged", () => {
			this.initDagreGraph();
		});
		this.editor.on("moduleChanged", () => {
			setTimeout(() => {
				this.layoutDagreGraph();
			}, 10);
		});

		this.editor.changeModule(activeModuleName);
	},

	initDagreGraph() {
		// @ts-expect-error
		this.editor.dagreGraph = new dagre.graphlib.Graph();
		this.editor.dagreGraph.setGraph({
			rankdir: "LR",
			// nodesep: 0,
			// edgesep: 0,
			ranksep: this.dagreRangSep,
			marginx: -50,
			marginy: -50,
		});
	},

	// This relies on the Vue items to add their data to the dagreGraph (in DrawflowHelpers.addToDagre)
	layoutDagreGraph() {
		// @ts-expect-error
		dagre.layout(this.editor.dagreGraph);
		pp.vue.bus.$emit("DRAWFLOW-graph-changed");
	},

	importNodesFromRails(importData, hideShellModalForm) {
		// pp.log("into importNodesFromRails", importData, hideShellModalForm);

		Object.values(importData).forEach((node) => {
			const moduleName = this.itemToModuleNames[node.html];
			// pp.log("at node, module", node, moduleName);
			if (node.data.old_fake_id) {
				this.convertMemNode(node, moduleName);
			} else if (this.editor.drawflow.drawflow[moduleName].data[node.id]) {
				this.editor.updateNodeDataFromId(node.id, node.data);
			} else {
				this.editor.drawflow.drawflow[moduleName].data[node.id] = node;
			}
		});
		if (hideShellModalForm) {
			$("#shell-modal").modal("hide");
		}
	},

	convertMemNode(node, moduleName) {
		const memNode = this.editor.getNodeFromId(node.data.old_fake_id);
		pp.log("- got provisional:", memNode);
		if (memNode) {
			const oldNodeId = memNode.id;
			this.editor.removeNodeId(oldNodeId);

			// Update DOM elements
			$(`#${oldNodeId}-modal`).attr("id", `${node.id}-modal`);
			node.pos_x = memNode.pos_x;
			node.pos_y = memNode.pos_y;
			// Forward to decide whether the edit form should be shown immediately
			node.pendingLoadEditForm = memNode.pendingLoadEditForm;

			pp.log("- merged", structuredClone(node));
		}

		if (node.data.child_of) {
			const parentNode = this.editor.getNodeFromId(node.data.child_of, true);
			pp.log("-- parent", parentNode);
			if (!Object.keys(parentNode.child_nodes).includes(node.id)) {
				parentNode.child_nodes[node.id] = node;
				pp.vue.bus.$emit("DRAWFLOW-child-nodes-changed", {
					nodeId: parentNode.id,
				});
			}
		} else {
			if (!memNode) {
				node.pos_x = node.pos_y = 100;
			}
			this.editor.importNode(node, moduleName);
		}
	},

	setupListeners() {
		this.editor.on("clickEnd", (event) => {
			this.handleClickEvent(this, event);
		});

		this.editor.on(
			"connectionCreated",
			({ output_id, input_id, output_class, input_class }) => {
				pp.log(
					"connectionCreated",
					output_id,
					input_id,
					output_class,
					input_class,
				);
			},
		);

		this.editor.on("contextmenu-canvas", (event) => {
			const $dropdown = $(this.emptyContextMenu);
			if (!this.dropdownElements) {
				return;
			}
			this.dropdownElements[this.editor.module].forEach((liElem) => {
				$(`<li>${liElem}</li>`).appendTo($dropdown.find(".dropdown-menu"));
			});
			const canvasZoomedDimensions = this.editor.canvasZoomedDimensions();

			const pos_x =
				this.editor.pos_x * canvasZoomedDimensions.width -
				this.editor.precanvas.getBoundingClientRect().x *
					canvasZoomedDimensions.width;
			const pos_y =
				this.editor.pos_y * canvasZoomedDimensions.height -
				this.editor.precanvas.getBoundingClientRect().y *
					canvasZoomedDimensions.height;
			$dropdown.css({ top: pos_y, left: pos_x });
			$(this.editor.precanvas).append($dropdown);
		});

		$("#export-modal").on("show.bs.modal", () => {
			$("#export-modal .modal-body").html(
				`<pre>${JSON.stringify(this.editor.export(), null, 2)}</pre>`,
			);
		});

		$("#import-modal")
			.find("button")
			.on("click", () => {
				const data = $("#import-modal").find("textarea").val();
				// pp.log("data", data);
				let jsonData;
				try {
					// @ts-expect-error
					jsonData = JSON.parse(data);
				} catch (e) {
					pp.log("catch", e);
					// @ts-expect-error
					pp.notifications.display("error", e.toString());
					return;
				}
				pp.log("got json from import", jsonData);
				const filteredData = {};

				Object.entries(jsonData.drawflow).forEach(
					([moduleName, moduleData]) => {
						filteredData[moduleName] = { data: {} };
						Object.entries(moduleData.data).forEach(([itemId, item]) => {
							if (!item.data.child_of) {
								filteredData[moduleName].data[itemId] = item;
							}
						});
					},
				);
				pp.log("filteredData", filteredData);
				this.initDagreGraph();
				this.editor.import({ drawflow: filteredData });
				setTimeout(() => {
					this.layoutDagreGraph();
				}, 100);
				$("#import-modal").modal("hide");
			});

		$(".j-module-link").on("click", (event) => {
			const moduleName = $(event.target).data("module");
			$(".j-module-link").addClass("button--secondary");
			$(".j-menu-modal-link").addClass("hidden");
			$(event.target).removeClass("button--secondary"); // Mark as active by not being "secondary"
			$(`.j-menu-modal-link[data-for='${moduleName}']`).removeClass("hidden");
			this.editor.changeModule(moduleName);
		});

		const that = this;
		$(".j-save-button").on("click", function () {
			DrawflowHelpers.saveToRails(that.editor);
		});
	},

	handleClickEvent(wrapperObj, event) {
		const $target = $(event.target);
		// For the dropdown elements which point to modals
		pp.log(
			"into handleClickEvent",
			event,
			document.elementsFromPoint(event.clientX, event.clientY),
		);

		const targetWithMethod = document
			.elementsFromPoint(event.clientX, event.clientY)
			.find((el) => {
				return $(el).data("methodName") !== undefined;
			});
		// pp.log("- targetWithMethod", targetWithMethod);
		if (targetWithMethod) {
			const $targetWithMethod = $(targetWithMethod);
			const methodName = $targetWithMethod.data("methodName");
			// pp.log("- calling", methodName);
			wrapperObj.buttonMethods[methodName](
				wrapperObj,
				$targetWithMethod,
				event,
			);
		} else if (
			!$target.closest(".modal").length &&
			$target.data("toggle") != "modal"
		) {
			// Always remove dropdown menu, but wait for bootstrap to open the modal
			$(wrapperObj.editor.precanvas).find(".dropdown").remove();
		}
	},

	buttonMethods: {
		addChildNode: (wrapperObj, $target, event) => {
			const $modal = $target.closest(".modal");
			const parentNodeId = $modal.attr("id").replace("-modal", "");
			pp.log("into addChildNode", $target, parentNodeId);
			const callback = () => {
				let parentNode = wrapperObj.editor.getNodeFromId(parentNodeId, true);
				const clone = wrapperObj.composeChildNode(
					parentNode,
					$modal.find("input:visible, option:selected"),
				);
				parentNode.child_nodes[clone.id] = clone;
				pp.vue.bus.$emit("DRAWFLOW-child-nodes-changed", {
					nodeId: parentNode.id,
				});

				pp.log("- added childNode:", clone, parentNode);
				$modal.modal("hide");
			};
			wrapperObj.validateFormAndCallback($modal, callback);
		},

		addNode: (wrapperObj, $target, event) => {
			const $formModal = $target.closest(".modal");
			const newName = $formModal.find("input[type='text']").val();
			pp.log("into addNode", wrapperObj, $target, $formModal);
			const callback = () => {
				const emptyParentNode =
					wrapperObj.emptyNodes[wrapperObj.editor.module].empty_parent_node;
				const clone = structuredClone(emptyParentNode);
				clone.child_nodes = {};
				clone.data[`${clone.html}_name`] = clone.name = newName; // Infer the necessary data from the html type
				clone.id = `m-${pp.viewHelpers.generateRandomId()}`;
				if ($(wrapperObj.editor.precanvas).find(".dropdown").length) {
					clone.pos_x = parseInt(
						$(wrapperObj.editor.precanvas).find(".dropdown").css("left"),
						10,
					);
					clone.pos_y = parseInt(
						$(wrapperObj.editor.precanvas).find(".dropdown").css("top"),
						10,
					);
					$(wrapperObj.editor.precanvas).find(".dropdown").remove();
				} else {
					clone.pos_x = clone.pos_y = 100;
				}
				if ($target.data("nodeData")) {
					// pp.log("- got extra node data", $target.data('nodeData'));
					Object.entries($target.data("nodeData")).forEach(([key, val]) => {
						clone[key] = val;
					});
				}
				const $inputs = $formModal.find(
					'input:visible, input[type="hidden"][data-column-name], option:selected',
				);
				if ($inputs.length) {
					wrapperObj.addDataToNodeFromInput(clone, null, $inputs);
				}

				if ($target.data("addToInvokingNode")) {
					pp.log("adding to", $target, $formModal, clone);
					const parentNodeId = $formModal.attr("id").replace("-modal", "");

					const parentNode = wrapperObj.editor.getNodeFromId(
						parentNodeId,
						true,
					);
					parentNode.child_nodes[clone.id] = clone;
					clone.data.child_of = parentNodeId;
					pp.vue.bus.$emit("DRAWFLOW-child-nodes-changed", {
						nodeId: parentNode.id,
					});
				} else {
					wrapperObj.editor.importNode(clone, wrapperObj.editor.module); // Should always be the editor's current module name
					$(`#${clone.id}`).css({ left: clone.pos_x, top: clone.pos_y }); // Will be overwritten if below block is executed
				}

				pp.log("- added node:", clone, $(`#${clone.id}`));

				$formModal.modal("hide");
				$formModal.find("input:visible").val("");

				if (clone.child_nodes) {
					// Should be an empty array
					// TODO open modal immediately
				}
			};
			wrapperObj.validateFormAndCallback($formModal, callback);
		},

		filterItems(wrapperObj, $target, event) {
			const $form = $target.closest(".modal-content").find("form");

			const idsToFilter = $form.find("select").val();
			if ($form.closest(".modal").attr("id") == "filter-actors-modal") {
				pp.vue.bus.$emit("DRAWFLOW-filter-actor-ids", {
					whitelistedActorIds: idsToFilter,
				});
			} else {
				// Else expect Article ids
				pp.vue.bus.$emit("DRAWFLOW-filter-article-ids", {
					whitelistedArticleIds: idsToFilter,
				});
			}
			setTimeout(() => {
				wrapperObj.layoutDagreGraph();
			}, 500);
		},
	},

	validateFormAndCallback($container, callback) {
		$container
			.find("input:visible, .select2-hidden-accessible")
			.each(function () {
				// @ts-expect-error
				$(this)
					.trigger("change.ClientSideValidations")
					.trigger("focusout.ClientSideValidations")
					.trigger("change");
			});
		setTimeout(() => {
			if (!$container.find(".Field-with-errors").length) {
				callback();
			} else {
				pp.log("found errors in", $container);
			}
		}, 10);
	},

	setupEditForm(json, status, request) {
		// pp.log("into setupEditForm -- json, status, request", json, status, request);
		$("#shell-modal .modal-body").html(json.html);
		$("#shell-modal").one("shown.bs.modal", () => {
			$(document).trigger("page:change");
		});
		$("#shell-modal")
			.addClass("modal--wide modal--with-max-height")
			.modal("show");
		$("#shell-modal").one("hide.bs.modal", () => {
			$("#shell-modal .modal-body").html("");
			$("#shell-modal").removeClass("modal--wide modal--with-max-height");
		});
	},

	composeChildNode(parentNode, $inputs) {
		pp.log("into composeChildNode", parentNode, $inputs);
		const emptyChildNode = this.emptyNodes[this.editor.module].empty_child_node;
		const clone = structuredClone(emptyChildNode);
		clone.name = $inputs.find("option:selected").text();
		clone.data.child_of = parentNode.id;
		this.addDataToNodeFromInput(clone, parentNode, $inputs);
		if (this.inputsForParentNode[this.editor.module]) {
			Object.entries(this.inputsForParentNode[this.editor.module]).forEach(
				([key, val]) => {
					// pp.log("- looking at input for parent node", key, val);
					if (!parentNode.data[key]) {
						return;
					}
					const inputsData = val[parentNode.data[key]];
					// pp.log("-- inputs", inputsData);
					if (!inputsData) {
						return;
					}
					Object.entries(inputsData).forEach(([inputName, inputType]) => {
						clone.inputs[inputName] = {
							connections: [],
							required: inputType == "req",
						};
					});
				},
			);
		}
		if (parentNode.data)
			// pp.log("- cloned:", clone);
			return clone;
	},

	addDataToNodeFromInput(node, parentNode, $inputs) {
		pp.log("into addDataToNodeFromInput", node, $inputs);
		$inputs.each((index, inputEl) => {
			const $inputEl = $(inputEl);
			if ($inputEl.data("columnName")) {
				node.data[$inputEl.data("columnName")] = $inputEl.val();
				return;
			}
			// Else
			Object.entries($inputEl.data()).forEach(([key, val]) => {
				if (key == "nodeIdAffix") {
					node.id = `${val}-${$inputEl.val()}-${parentNode.id}`;
				} else if (key != "select2Id") {
					node.data[key.replace(/([A-Z])/g, "_$1").toLowerCase()] = val; // Convert to spider_case
				}
			});
		});
	},
};

export default DrawflowWrapper;
